import _createStore from 'redux/store'
import createReducers from './createReducers'


let _store

const reducers = createReducers(() => _store.dispatch)

const getState = () => {
  if (process.env.WEBPACK === 'build.server') {
    console.error('DON\'T USE getState() ON SERVER SIDE!')
  }
  else {
    return _store ? _store.getState() : {}
  }
}

const createStore = (...args) => {
  const { store, storeEvents } = _createStore(...args)

  _store = store

  return { store, storeEvents }
}


export {
  createStore,
  getState,
  reducers,
}
